import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import axios from "axios";
import { AuthShell } from "@/pages/Login";
import { API, formatApiError } from "@/lib/newsUtils";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading"); // loading | done | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Falta el enlace de baja.");
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/unsubscribe`, { token });
        setMessage(data.email || "");
        setStatus("done");
      } catch (err) {
        setMessage(formatApiError(err.response?.data?.detail, err.message));
        setStatus("error");
      }
    })();
  }, [token]);

  return (
    <AuthShell
      title="Baja de emails"
      subtitle="Gestiona tus notificaciones de News Digest."
    >
      <div className="space-y-5" data-testid="unsubscribe-page">
        {status === "loading" && (
          <div className="flex items-center gap-2 text-muted-foreground" data-testid="unsubscribe-loading">
            <Loader2 className="w-4 h-4 animate-spin" />
            <span className="text-sm">Procesando tu baja...</span>
          </div>
        )}
        {status === "done" && (
          <div className="space-y-3" data-testid="unsubscribe-success">
            <div className="flex items-center gap-2 text-primary">
              <CheckCircle2 className="w-5 h-5" />
              <p className="font-semibold">Te has dado de baja</p>
            </div>
            <p className="text-sm text-muted-foreground">
              {message ? <>Ya no enviaremos el resumen por email a <b>{message}</b>.</> : "Ya no recibirás el resumen por email."}
              {" "}Puedes volver a activarlo cuando quieras desde <b>Ajustes</b>.
            </p>
          </div>
        )}
        {status === "error" && (
          <div className="space-y-3" data-testid="unsubscribe-error">
            <div className="flex items-center gap-2 text-destructive">
              <XCircle className="w-5 h-5" />
              <p className="font-semibold">No se pudo procesar la baja</p>
            </div>
            <p className="text-sm text-muted-foreground">{message}</p>
          </div>
        )}
        <Link to="/" className="inline-block text-sm text-primary font-semibold hover:underline">
          Ir a News Digest →
        </Link>
      </div>
    </AuthShell>
  );
}
